import {
  Box,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  Skeleton,
  Chip,
  Button,
  CircularProgress,
  InputAdornment,
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import {
  primaryBtnTeal,
  selectFieldPrep,
  slotChip,
  textfieldTextPrep,
} from "../../../style/PatientDetailsStyle";
import { menuItemStyle, primaryBtn } from "../../../style/AppointmentStyle";
import { useSelector } from "react-redux";
import { TreatmentList } from "../../../connections/getApi";
import { getSplInst } from "../../../connections/getApi";
import { getDiagnosisRecommendations } from "../../../connections/getApi";
import { diagnosisSearch } from "../../../connections/getApi";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import MicIcon from "@mui/icons-material/Mic";
import useDebounce from "../../../hooks/UseDebounce";
import UseGetTreatmentShortCodeList from "../../../helper/UseGetTreatmentShortCodeList";
import UseGetSelectTreatementId from "../../../helper/UseGetSelectTreatementId";
import { useTour } from "@reactour/tour";
import {
  generateNote,
  uploadAudio,
  postTreatmentTemplates,
  ExtractMedicineSummaryV1,
} from "../../../connections/postApi";
import { updateTreatments } from "../../../connections/putApi";
import { showToast } from "../../../utils/toastUtil";
import UseFetchSummaryOfPatient from "../../../helper/UseFetchSummaryOfPatient";
import PatientSummaryDialog from "../../CustomModal/PatientSummaryDialog";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import CustomModal from "../../CustomModal/CustomModal";
import DAS28 from "../../ModalChildren/DAS28";
import HistoryDas28 from "../../ModalChildren/HistoryDas28";
import UseFetchDas28History from "../../../helper/UseFetchDas28History";
import DiagnosisTreatment from "../../../assets/diagnosis_treatment.svg";
import UseFetchOrgBaseFeatures from "../../../helper/UseFetchOrgBaseFeatures";
import useVoiceToText from "../../../hooks/useVoiceToText";
import MicButton from "../../../hooks/MicButton";
import { uploadFileToS3 } from "../../../connections/s3Upload";
import { AudioRecorder } from "react-audio-voice-recorder";
import UseFetchAiSummaryS3 from "../../../helper/UseFetchAiSummaryS3";
import SOAP from "../../ModalChildren/SOAP";
import JointAssessment from "../jointDiagram";
import OCRModal from "../../ModalChildren/OCRModal";
import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import RecordVoiceOverOutlinedIcon from "@mui/icons-material/RecordVoiceOverOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import DocumentScannerOutlinedIcon from "@mui/icons-material/DocumentScannerOutlined";

const TreatmentDetail = ({ commonData, setCommonData }) => {
  const prescriptionData = useSelector(
    (state) => state.prescription.prescriptionData,
  );

  const { currentStep, isOpen, setCurrentStep } = useTour();

  // const dispatch = useDispatch();
  //  console.log(prescriptionData)

  const [treatments, setTreatments] = useState([]);
  const [dasCalculatorModal, setDasCalculatorModal] = useState(false);
  const [dasCalculatorHistoryModal, setDasCalculatorHistoryModal] =
    useState(false);
  const [selectedTreatmentId, setSelectedTreatmentId] = useState(null);
  const [data, setData] = useState({
    diagnosis: "",
    notes: "",
    selfNotes: "",
    splInst: "",
    medicalTests: "",
  });
  const [medicines, setMedicines] = useState([]);
  // const [selectedChips, setSelectedChips] = useState([]);

  // Fetch Treatment List on Component Mount
  const fetchTreatments = async () => {
    const treatmentListData = await TreatmentList();
    if (treatmentListData) {
      setTreatments(treatmentListData?.treatments);
    }
  };

  useEffect(() => {
    fetchTreatments();
  }, []);

  // console.log(prescriptionData);

  useEffect(() => {
    // Update form data with prescriptionData on load
    // if (prescriptionData) {
    setData({
      diagnosis: prescriptionData?.diagnosis_list || "",
      notes: prescriptionData?.notes || "",
      selfNotes: prescriptionData?.self_notes || "",
      splInst: prescriptionData?.special_instructions || "",
      medicalTests: prescriptionData?.medical_tests_list || "",
    });
    // }
    setMedicines(prescriptionData?.medicines || []);
    setSelectedTreatmentId(null);
    setCurrentTemplateId(null);
    setAiDiagnosis(null);
    isDiagnosisTyping.current = false;
  }, [prescriptionData]);

  // Fetch Treatment details based on selected ID

  const { data: treatmentDetails, isLoading } =
    UseGetSelectTreatementId(selectedTreatmentId);

  //  console.log(treatmentDetails);
  useEffect(() => {
    if (selectedTreatmentId) {
      const fetchSelectedTreatment = async () => {
        //  const treatmentDetails = await selectedTreatment(selectedTreatmentId);
        if (treatmentDetails) {
          setData({
            diagnosis: treatmentDetails?.diagnosis || "",
            notes: "",
            selfNotes: treatmentDetails?.self_notes || "",
            splInst: treatmentDetails?.special_instructions || "",
            medicalTests: treatmentDetails?.medical_tests,
          });
          const mappedMedicines = (treatmentDetails?.medicines || []).map(
            (m) => ({
              id: m?.medicine_id || "",
              name: m?.name || "",
              description: m?.description || m?.dosage || "",
              remark: m?.remark || "",
            }),
          );
          setMedicines(mappedMedicines);
        }
      };
      fetchSelectedTreatment();
    }
  }, [selectedTreatmentId, treatmentDetails]);

  const handleTreatmentChange = (event) => {
    const selectedId = event.target.value;
    setSelectedTreatmentId(selectedId);
  };

  const handleInputChange = (field) => (event) => {
    setData((prevData) => ({
      ...prevData,
      [field]: event.target.value,
    }));
  };

  // for handle splINSt change
  // const handleChangeSplInst = async (chip) => {

  //   let res = await getSplInst(chip);
  //   if (res) {
  //     setData((prevData) => ({
  //       ...prevData,
  //       splInst: data.splInst + " " + (res?.value || ""),
  //     }));
  //   }
  // };

  // Diagnosis search dropdown state
  const [diagnosisSuggestions, setDiagnosisSuggestions] = useState([]);
  const [diagnosisSearching, setDiagnosisSearching] = useState(false);
  const [showDiagnosisDrop, setShowDiagnosisDrop] = useState(false);
  const [diagnosisFocusedIndex, setDiagnosisFocusedIndex] = useState(0);
  const diagnosisFieldRef = React.useRef(null);
  const isDiagnosisTyping = React.useRef(false);

  // Inside TreatmentDetail component, replace the old voice state with:
  const makeSetter = (field) => (updater) =>
    setData((prev) => ({
      ...prev,
      [field]: typeof updater === "function" ? updater(prev[field]) : updater,
    }));

  const diagnosisMic = useVoiceToText(makeSetter("diagnosis"));
  const notesMic = useVoiceToText(makeSetter("notes"));
  const selfNotesMic = useVoiceToText(makeSetter("selfNotes"));
  const splInstMic = useVoiceToText(makeSetter("splInst"));

  // Extract the last segment (after last comma) for searching
  const getCurrentDiagnosisWord = (value) => {
    const parts = value.split(",");
    return parts[parts.length - 1].trim();
  };

  const debouncedDiagnosisWord = useDebounce(
    getCurrentDiagnosisWord(data.diagnosis),
    400,
  );

  useEffect(() => {
    const word = debouncedDiagnosisWord;
    if (!word || !isDiagnosisTyping.current) {
      setDiagnosisSuggestions([]);
      setShowDiagnosisDrop(false);
      return;
    }
    let cancelled = false;
    setDiagnosisSearching(true);
    diagnosisSearch(word)
      .then((res) => {
        if (cancelled) return;
        const list = res?.payload?.diagnoses || [];
        setDiagnosisSuggestions(list);
        setShowDiagnosisDrop(list.length > 0);
        setDiagnosisFocusedIndex(0);
        setDiagnosisSearching(false);
      })
      .catch(() => {
        if (!cancelled) setDiagnosisSearching(false);
      });
    return () => {
      cancelled = true;
    };
  }, [debouncedDiagnosisWord]);

  const handleDiagnosisSuggestionSelect = (suggestion) => {
    const parts = data.diagnosis.split(",");
    parts[parts.length - 1] = " " + suggestion.value;
    const newValue = parts.join(",") + ", ";
    setData((prev) => ({ ...prev, diagnosis: newValue }));
    setShowDiagnosisDrop(false);
    setDiagnosisSuggestions([]);
  };

  // AI template search
  const debouncedDiagnosis = useDebounce(data.diagnosis, 800);
  const [aiLoading, setAiLoading] = useState(false);
  const [aiResult, setAiResult] = useState(null);
  const [aiDiagnosis, setAiDiagnosis] = useState(null);
  const [currentTemplateId, setCurrentTemplateId] = useState(null);
  const [templateSaving, setTemplateSaving] = useState(false);
  const [smartPrompt, setSmartPrompt] = useState(false);
  const [templateNameDialog, setTemplateNameDialog] = useState(false);
  const [templateName, setTemplateName] = useState("");

  // Reset AI result when diagnosis changes
  useEffect(() => {
    setAiResult(null);
    setSmartPrompt(false);
  }, [debouncedDiagnosis]);

  const doctorId =
    commonData?.patientForm?.consultancyDoctor ||
    prescriptionData?.appointment?.doctor?.id;

  // Build payload from all current prescription fields + latest medicines/tests from Medicine.jsx
  const buildTemplatePayload = (name) => {
    const splitTrim = (str) =>
      str
        ? str
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean)
        : [];

    const diagnosisArr = splitTrim(data.diagnosis);
    const splInstArr = splitTrim(data.splInst);

    // Prefer the latest medical tests edited by the user in Medicine.jsx
    const latestMedicalTests =
      commonData?.currentMedicalTests ?? data.medicalTests;
    const medTestArr = splitTrim(latestMedicalTests);

    // Prefer the latest medicines edited by the user in Medicine.jsx
    const latestMedicines = commonData?.currentMedicines || medicines;
    const allSystemMedicines = latestMedicines
      .filter((m) => m.id && m.id !== "" && m.name)
      .map((m) => ({
        medicine_id: m.id,
        medicine_description: m.description ? [m.description] : [],
        medicine_remark: m.remark ? [m.remark] : [],
      }));

    return {
      treatment: {
        name: name || diagnosisArr[0] || data.diagnosis,
        diagnosis: diagnosisArr,
        notes: data.notes || "",
        self_notes: data.selfNotes || "",
        special_instructions: splInstArr,
        medical_tests: medTestArr,
        ...(allSystemMedicines.length > 0 && {
          treatment_medicines_attributes: allSystemMedicines,
        }),
      },
    };
  };

  const handleAiSearch = async () => {
    if (!debouncedDiagnosis) return;
    setAiLoading(true);
    setAiResult(null);
    setSmartPrompt(false);
    try {
      const res = await getDiagnosisRecommendations(
        debouncedDiagnosis,
        "diagnosis",
        doctorId || 1,
      );
      if (res?.data) {
        setAiResult(res.data);

        if (res.data.template === true) {
          // ✅ Updated: use templates instead of treatments
          const templatesArr = res.data.summaries?.templates || [];

          if (templatesArr.length > 0) {
            const treatmentId = templatesArr[0]?.treatment_id;

            if (treatmentId) {
              setCurrentTemplateId(treatmentId);
              setSelectedTreatmentId(treatmentId);
            }
          }
        } else {
          // No template: apply AI-suggested medicines
          const mappedMedicines = (res?.data?.summaries?.medicines || []).map(
            (m) => ({
              id: m?.medicine_id || "",
              name: m?.name || "",
              description: m?.dosage || "",
              remark: m?.remark || "",
            }),
          );
          if (mappedMedicines?.length > 0) {
            setMedicines(mappedMedicines);
          }
        }
        // Sync diagnosis field with response and track it for change detection
        const normalizedDiagnosis =
          res.data.diagnosis?.length > 0
            ? res.data.diagnosis.join(", ")
            : debouncedDiagnosis;
        if (res.data.diagnosis?.length > 0) {
          setData((prev) => ({
            ...prev,
            diagnosis: normalizedDiagnosis,
          }));
        }
        setAiDiagnosis(normalizedDiagnosis);
        // Smart template suggestion: counter >= 2 and no template exists
        if (res.data.counter >= 2 && res.data.template === false) {
          setTemplateName("");
          setSmartPrompt(true);
        }
      }
    } finally {
      setAiLoading(false);
    }
  };

  const handleAddTemplate = async (name) => {
    setTemplateSaving(true);
    try {
      const payload = buildTemplatePayload(name);
      const res = await postTreatmentTemplates(payload);
      if (res?.status?.status === "SUCCESS") {
        showToast("Template added successfully", "SUCCESS");
        setAiResult(null);
        setSmartPrompt(false);
        setTemplateNameDialog(false);
        setTemplateName("");
        fetchTreatments();
      } else {
        showToast(res?.status?.message || "Failed to add template", "ERROR");
      }
    } finally {
      setTemplateSaving(false);
    }
  };

  const handleUpdateTemplate = async () => {
    const treatmentsArr = aiResult?.summaries?.treatments || [];
    const templateId =
      treatmentsArr.length > 0 ? Object.values(treatmentsArr[0])[0] : null;
    if (!templateId) return;
    setTemplateSaving(true);
    try {
      const payload = buildTemplatePayload();
      const res = await updateTreatments(payload, templateId);
      if (res?.status?.status === "SUCCESS") {
        showToast("Template updated successfully", "SUCCESS");
        setAiResult(null);
        fetchTreatments();
      } else {
        showToast(res?.status?.message || "Failed to update template", "ERROR");
      }
    } finally {
      setTemplateSaving(false);
    }
  };

  const { data: treatmentShortCodeList } = UseGetTreatmentShortCodeList();
  // console.log(treatmentShortCodeList);

  // console.log(isLoading);

  const handleChangeSplInst = async (chip) => {
    let res = await getSplInst(chip);
    if (res) {
      const newInstruction = res.value || "";

      // Split the current splInst by comma and trim whitespace from each entry
      const currentInstructions = data.splInst
        .split(",")
        .map((inst) => inst.trim())
        .filter(Boolean); // filter(Boolean) removes empty strings

      // Check if the new instruction already exists
      if (!currentInstructions.includes(newInstruction)) {
        // Add the new instruction to the array
        currentInstructions.push(newInstruction);

        // Join the array back into a string with commas
        const updatedInstructions = currentInstructions.join(", ");

        setData((prevData) => ({
          ...prevData,
          splInst: updatedInstructions,
        }));
      }
    }
  };

  useEffect(() => {
    setCommonData((prev) => ({
      ...prev,
      treatmentDetail: data,
      medicines: medicines,
      treatments,
    }));
  }, [treatments, data, medicines, setCommonData]);

  // console.log(medicines, "treatment detail medicines");
  const handleKeyDown = (e, field) => {
    if (e.key === "Tab" && field === "diagnosis") {
      if (currentStep === 2 && isOpen) {
        setTimeout(() => {
          document.getElementById(`notes`).focus();
        }, 0);
        setCurrentStep(3);
      }
    } else if (e.key === "Tab" && field === "notes") {
      if (currentStep === 3 && isOpen) {
        setTimeout(() => {
          document.getElementById(`self_notes`).focus();
        }, 0);
        setCurrentStep(4);
      }
    } else if (e.key === "Tab" && field === "selfNotes") {
      if (currentStep === 4 && isOpen) {
        setTimeout(() => {
          document.getElementById(`special_instructions`).focus();
        }, 0);
        setCurrentStep(5);
      } else {
        setTimeout(() => {
          document.getElementById(`special_instructions`).focus();
        }, 0);
      }
    } else if (e.key === "Tab" && field === "splInst") {
      if (currentStep === 5 && isOpen) {
        // setTimeout(() => {
        //   document.getElementById(`special_instructions`).focus();
        // }, 0);
        setCurrentStep(6);
      }
    }
  };

  const patientDetailsData = useSelector(
    (state) => state.prescription.patientDetailsData,
  );
  const appointmentData = useSelector(
    (state) => state.prescription.appointmentData,
  );

  const ocrJob = useSelector(
    (s) => s.ocr.jobs[`${patientDetailsData?.id}_${appointmentData?.id}`],
  );
  const isOcrProcessing = ["processing", "extracting"].includes(ocrJob?.status);

  const [openSummaryModal, setOpenSummaryModal] = useState(false);

  const { data: voiceSummary, refetch } = UseFetchSummaryOfPatient(
    appointmentData?.id,
  );
  const { data: featureOrgBase } = UseFetchOrgBaseFeatures();
  // console.log(featureOrgBase);

  const isDas28Enabled = featureOrgBase?.payload?.features?.some(
    (feature) => feature?.key === "dash28" && feature?.active === true,
  );
  // const isDas28Enabled = true;
  const isJointDiagramEnabled = featureOrgBase?.payload?.features?.some(
    (feature) => feature?.key === "joint_diagram" && feature?.active === true,
  );
  const patientDoctorConversationEnabled =
    featureOrgBase?.payload?.features?.some(
      (feature) =>
        feature?.key === "consultation_summary" && feature?.active === true,
    );
  const isOcrEnabled = featureOrgBase?.payload?.features?.find(
    (feature) => feature?.key === "medical_file" && feature?.active === true,
  );

  const handleOpenSummary = async () => {
    await refetch(); // make sure latest data is fetched
    setOpenSummaryModal(true); // open modal
  };

  const handleCloseSummary = () => {
    setOpenSummaryModal(false);
  };

  const { data: historyList } = UseFetchDas28History(patientDetailsData?.id);

  // console.log(voiceSummary, 'voiceSummary');
  // const hostname = window.location.hostname;

  const { data: consultationSummary, isLoading: consultationSummaryLoading } =
    UseFetchAiSummaryS3(
      "consultation_summary",
      appointmentData?.id,
      "Appointment",
    );

  useEffect(() => {
    setSoapSummary(null);
    if (consultationSummary?.payload?.summary) {
      setSoapSummary(consultationSummary?.payload?.summary);
    }
  }, [consultationSummary]);

  const [isUploading, setIsUploading] = useState(false);
  const [openSoapModal, setOpenSoapModal] = useState(false);
  const [openJointModal, setJointModal] = useState(false);
  const [openOcrModal, setOcrModal] = useState(false);
  const [soapSummary, setSoapSummary] = useState(null);
  const [ocrResults, setOcrResults] = useState([]);

  const addAudioElement = async (blob) => {
    // Create local URL for immediate playback
    const url = URL.createObjectURL(blob);
    const audio = document.createElement("audio");
    audio.src = url;
    audio.controls = true;
    document.body.appendChild(audio);

    // Optional: Show uploading state
    setIsUploading(true);

    try {
      // Prepare file with proper name and type
      const fileName = `voice_note_${Date.now()}.webm`;
      const file = new File([blob], fileName, {
        type: "audio/webm",
      });

      // Upload to S3 and get the file URL

      const { key } = await uploadFileToS3(
        file,
        "Appointment", //  model
        appointmentData?.id, //  record_id no need to send
        "voice",
      );

      const extractResponse = await ExtractMedicineSummaryV1(
        key,
        "consultation_summary",
        "Appointment",
        appointmentData?.id,
      );
      if (extractResponse?.payload?.summaries) {
        setSoapSummary(extractResponse.payload.summaries);
        setOpenSoapModal(true);
        showToast("SOAP Note generated successfully", "SUCCESS");
      } else {
        showToast("Failed to generate SOAP note", "ERROR");
      }

      // Optional: You can now send `result.file_url` to your backend
      // if needed for prescription/visit association
    } catch (error) {
      console.error("❌ Audio upload failed:", error);
      showToast("Failed to upload voice note", "ERROR");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Box
      p={2}
      sx={{
        backgroundColor: "neutral.prescriptionBackGround",
        ml: -1,
        mt: -4,
      }}
    >
      {/* Clinical Assistant Tools Tools  */}
      {(isJointDiagramEnabled ||
        patientDoctorConversationEnabled ||
        isDas28Enabled ||
        isOcrEnabled) && (
        <Box
          sx={{
            backgroundColor: "neutral.white",
            borderRadius: "10px",
            boxShadow: "none",
            border: "1px solid #e0e0e0",
            p: 2,
            mb: 2,
            mt: -3,
            "&:before": { display: "none" },
          }}
        >
          {/* ── Header ── */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1,
            }}
          >
            <Box
              sx={{
                alignItems: "center",
                display: "flex",
                gap: 2,
                mb: 2,
                ml: "0px",
              }}
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  minWidth: 40,
                  backgroundColor: "neutral.blackBorder",
                  borderRadius: "50%",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <HandymanOutlinedIcon
                  sx={{ color: "neutral.teal", fontSize: 15 }}
                />
              </Box>
              <Typography fontWeight={600}>
                {" "}
                Clinical Assistant Tools
              </Typography>
            </Box>

            {/* <Tooltip title={showToolConfig ? "Close" : "Configure tools"}>
            <IconButton
              size="small"
              onClick={() => setShowToolConfig((p) => !p)}
              sx={{ color: showToolConfig ? "neutral.teal" : "text.secondary", p: 0.4 }}
            >
              <TuneOutlinedIcon sx={{ fontSize: 17 }} />
            </IconButton>
          </Tooltip> */}
          </Box>

          {/* ── Tool groups ── */}
          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexWrap: "wrap",
              alignItems: "flex-start",
            }}
          >
            {/* Group 1: Patient Conversation — full width row */}
            {patientDoctorConversationEnabled && (
              <Box
                sx={{
                  flex: "1 0 auto",
                  p: 1,
                  backgroundColor: "#f7fbfb",
                  borderRadius: 1,
                  border: "1px solid #ddeeed",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    mb: 0.75,
                  }}
                >
                  <RecordVoiceOverOutlinedIcon
                    sx={{ fontSize: 13, color: "neutral.teal" }}
                  />
                  <Typography
                    variant="caption"
                    sx={{
                      color: "neutral.teal",
                      fontWeight: 700,
                      fontSize: "0.68rem",
                      textTransform: "uppercase",
                      letterSpacing: 0.4,
                    }}
                  >
                    Patient Conversation
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                  }}
                >
                  <Tooltip
                    title={
                      isUploading
                        ? "Uploading in progress..."
                        : !appointmentData?.id
                          ? "Please select a patient who has an appointment first."
                          : ""
                    }
                  >
                    <span>
                      <Box
                        sx={{
                          pointerEvents:
                            isUploading || !appointmentData?.id
                              ? "none"
                              : "auto",
                          opacity:
                            isUploading || !appointmentData?.id ? 0.5 : 1,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {isUploading ? (
                          <CircularProgress size={30} />
                        ) : (
                          <AudioRecorder
                            onRecordingComplete={addAudioElement}
                            audioTrackConstraints={{
                              noiseSuppression: true,
                              echoCancellation: true,
                            }}
                            downloadOnSavePress={false}
                            downloadFileExtension="webm"
                          />
                        )}
                      </Box>
                    </span>
                  </Tooltip>

                  {patientDoctorConversationEnabled && soapSummary && (
                    <Button
                      onClick={() => setOpenSoapModal(true)}
                      sx={{
                        ...primaryBtn,
                        py: 1,
                        height: "34px",
                        fontSize: "0.76rem",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Show SOAP
                    </Button>
                  )}
                </Box>
              </Box>
            )}

            {/* Group 2: Joint Assessment */}
            {isJointDiagramEnabled && (
              <Box
                sx={{
                  flex: "1 1 auto",
                  p: 1,
                  backgroundColor: "#f7fbfb",
                  borderRadius: 1,
                  border: "1px solid #ddeeed",
                  minHeight: "62px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    mb: 0.75,
                  }}
                >
                  <AccountTreeOutlinedIcon
                    sx={{ fontSize: 13, color: "neutral.teal" }}
                  />
                  <Typography
                    variant="caption"
                    sx={{
                      color: "neutral.teal",
                      fontWeight: 700,
                      fontSize: "0.68rem",
                      textTransform: "uppercase",
                      letterSpacing: 0.4,
                    }}
                  >
                    Joint Assessment
                  </Typography>
                </Box>
                <Tooltip
                  title={
                    !patientDetailsData?.id || !appointmentData?.id
                      ? "Please select a patient who has an appointment first."
                      : ""
                  }
                >
                  <span>
                    <Button
                      onClick={() => setJointModal(true)}
                      sx={{
                        ...primaryBtn,
                        py: 0.5,
                        fontSize: "0.76rem",
                        height: "34px",
                        whiteSpace: "nowrap",
                        gap: 0.75,
                      }}
                      disabled={!patientDetailsData?.id || !appointmentData?.id}
                    >
                      <AccountTreeOutlinedIcon sx={{ fontSize: 15 }} />
                      Joint Diagram
                    </Button>
                  </span>
                </Tooltip>
              </Box>
            )}

            {/* Group 3: DAS28 Score */}
            {isDas28Enabled &&
              patientDetailsData?.id &&
              appointmentData?.id && (
                <Box
                  sx={{
                    flex: "1 1 auto",
                    p: 1,
                    backgroundColor: "#f7fbfb",
                    borderRadius: 1,
                    border: "1px solid #ddeeed",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      mb: 0.75,
                    }}
                  >
                    <AssessmentOutlinedIcon
                      sx={{ fontSize: 13, color: "neutral.teal" }}
                    />
                    <Typography
                      variant="caption"
                      sx={{
                        color: "neutral.teal",
                        fontWeight: 700,
                        fontSize: "0.68rem",
                        textTransform: "uppercase",
                        letterSpacing: 0.4,
                      }}
                    >
                      DAS28 Score
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      flexWrap: "wrap",
                    }}
                  >
                    <Button
                      sx={{
                        ...primaryBtn,
                        py: 0.5,
                        fontSize: "0.76rem",
                        gap: 0.75,
                      }}
                      onClick={() => setDasCalculatorModal(true)}
                    >
                      <CalculateOutlinedIcon sx={{ fontSize: 15 }} />
                      DAS28 Calculator
                    </Button>
                  </Box>
                  {historyList?.payload?.das28_scores?.length > 0 && (
                    <Typography
                      variant="body_Grey"
                      sx={{ fontSize: "0.7rem", mt: 0.5, display: "block" }}
                    >
                      Latest:{" "}
                      {historyList.payload.das28_scores[0]?.das28_esr_score} —{" "}
                      {
                        historyList.payload.das28_scores[0]
                          ?.activity_level_description
                      }
                    </Typography>
                  )}
                </Box>
              )}

            {/* Group 4: OCR — Medical Image Analysis */}
            {isOcrEnabled && (
              <Box
                sx={{
                  flex: "1 1 auto",
                  p: 1,
                  backgroundColor: "#f7fbfb",
                  borderRadius: 1,
                  border: "1px solid #ddeeed",
                  minHeight: "62px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    mb: 0.75,
                  }}
                >
                  <DocumentScannerOutlinedIcon
                    sx={{ fontSize: 13, color: "neutral.teal" }}
                  />
                  <Typography
                    variant="caption"
                    sx={{
                      color: "neutral.teal",
                      fontWeight: 700,
                      fontSize: "0.68rem",
                      textTransform: "uppercase",
                      letterSpacing: 0.4,
                    }}
                  >
                    Image Analysis
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    onClick={() => setOcrModal(true)}
                    sx={{
                      ...primaryBtn,
                      py: 0.5,
                      fontSize: "0.76rem",
                      height: "34px",
                      whiteSpace: "nowrap",
                      gap: 0.75,
                    }}
                  >
                    <DocumentScannerOutlinedIcon sx={{ fontSize: 15 }} />
                    OCR / Scan
                  </Button>

                  {isOcrProcessing && (
                    <Box
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.6,
                        px: 1.2,
                        py: 0.4,
                        borderRadius: "20px",
                        backgroundColor: "#fff7ed",
                        border: "1px solid #fed7aa",
                        cursor: "pointer",
                      }}
                      onClick={() => setOcrModal(true)}
                    >
                      <CircularProgress size={10} sx={{ color: "#ea580c" }} />
                      <Typography
                        sx={{
                          fontSize: "11px",
                          fontWeight: 700,
                          color: "#ea580c",
                        }}
                      >
                        {ocrJob?.status === "extracting"
                          ? "Generating summary…"
                          : `OCR: ${ocrJob?.files?.filter((f) => ["done", "error"].includes(f.status)).length ?? 0}/${ocrJob?.files?.length ?? 0} files`}
                      </Typography>
                    </Box>
                  )}

                  {ocrJob?.status === "done" && ocrResults.length === 0 && (
                    <Button
                      onClick={() => setOcrModal(true)}
                      sx={{
                        ...primaryBtn,
                        py: 1,
                        height: "34px",
                        fontSize: "0.76rem",
                        whiteSpace: "nowrap",
                      }}
                    >
                      View Results
                    </Button>
                  )}

                  {ocrResults.length > 0 && !isOcrProcessing && (
                    <Button
                      onClick={() => setOcrModal(true)}
                      sx={{
                        ...primaryBtn,
                        py: 1,
                        height: "34px",
                        fontSize: "0.76rem",
                        whiteSpace: "nowrap",
                      }}
                    >
                      View Results
                    </Button>
                  )}
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      )}

      {/* Diagnosis & Treatment */}
      <Box
        sx={{
          backgroundColor: "neutral.white",
          borderRadius: "10px",
          boxShadow: "none",
          border: "1px solid #e0e0e0",
          p: 2,
          "&:before": { display: "none" },
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            gap: 2,
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              gap: 2,
              mb: 2,
              ml: "0px",
            }}
          >
            <Box
              sx={{
                width: 40,
                height: 40,
                minWidth: 40,
                backgroundColor: "neutral.blackBorder",
                borderRadius: "50%",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
              }}
            >
              {/* <BiotechOutlinedIcon sx={{ color: 'neutral.teal' }} /> */}
              <img src={DiagnosisTreatment} alt="diag_icon" />
            </Box>
            <Typography fontWeight={600}>Diagnosis & Treatment</Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
            }}
          >
            {aiResult &&
              (aiResult.template === true && data.diagnosis === aiDiagnosis ? (
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleUpdateTemplate}
                  disabled={templateSaving}
                  sx={{
                    borderColor: "neutral.teal",
                    color: "neutral.teal",
                    whiteSpace: "nowrap",
                    textTransform: "none",
                    fontSize: "13px",
                    height: "40px",
                    borderRadius: "8px",
                    width: "196px",
                    "&:hover": { backgroundColor: "rgba(0,122,153,0.08)" },
                  }}
                >
                  {templateSaving ? (
                    <CircularProgress
                      size={14}
                      sx={{ color: "neutral.teal" }}
                    />
                  ) : (
                    "Update Template"
                  )}
                </Button>
              ) : (
                <Button
                  size="medium"
                  variant="outlined"
                  onClick={() => {
                    setTemplateName("");
                    setTemplateNameDialog(true);
                  }}
                  disabled={templateSaving}
                  sx={{
                    borderColor: "neutral.teal",
                    color: "neutral.teal",
                    whiteSpace: "nowrap",
                    textTransform: "none",
                    fontSize: "13px",
                    height: "40px",
                    borderRadius: "8px",
                    width: "180px",
                    "&:hover": { backgroundColor: "rgba(0,122,153,0.08)" },
                  }}
                >
                  {templateSaving ? (
                    <CircularProgress
                      size={14}
                      sx={{ color: "neutral.teal" }}
                    />
                  ) : (
                    "Save as Template"
                  )}
                </Button>
              ))}
            <FormControl fullWidth variant="outlined">
              <Select
                sx={{ ...selectFieldPrep, height: "40px", minWidth: "200px" }}
                value={selectedTreatmentId || "default"}
                onChange={handleTreatmentChange}
                displayEmpty
              >
                <MenuItem value="default" disabled>
                  Select Treatment
                </MenuItem>
                {treatments?.map(([treatmentName, id]) => (
                  <MenuItem
                    key={id}
                    value={id}
                    sx={{
                      ...menuItemStyle,
                      "& :hover": {
                        color: "black",
                      },
                    }}
                  >
                    {treatmentName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {voiceSummary?.status?.status === "SUCCESS" && (
              <Tooltip title="View Patient's Summary Recorded by Nurse">
                <Typography
                  variant="subtitle1"
                  color="neutral.teal"
                  sx={{ whiteSpace: "nowrap", cursor: "pointer" }}
                  onClick={handleOpenSummary}
                >
                  View Summary
                </Typography>
              </Tooltip>
            )}
          </Box>
        </Box>

        <Box
          sx={{ p: 0, mb: 1, marginRight: "0px" }}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Grid
            p={0}
            item
            xs={12}
            sm={12}
            md={voiceSummary?.status?.status === "SUCCESS" ? 5 : 4}
          ></Grid>

          {/* <Grid item xs={12} sm={4} md={3}> */}
          {/* <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            {
              loading ? <> <CircularProgress size={22} /> <Typography > Processing audio...</Typography></>
                :
                <AudioRecorder
                  onRecordingComplete={handleAudioSubmit}
                  audioTrackConstraints={{
                    noiseSuppression: true,
                    echoCancellation: true,
                  }}
                  downloadOnSavePress={false}
                  downloadFileExtension="wav"
                />
            }


          </Box> */}
          {/* </Grid> */}

          <Grid textAlign={"end"} item md={5}>
            {true && (
              <Typography color={"neutral.black"} variant="heading2_14">
                {/* Dr Bharti Aggarwal */}
                {prescriptionData?.appointment?.doctor?.full_name
                  ? `Consultancy : ${prescriptionData?.appointment?.doctor?.full_name}`
                  : " "}
              </Typography>
            )}
          </Grid>
        </Box>

        <Grid sx={{ p: 0 }} container spacing={1} mt={0.5}>
          <Grid item xs={12}>
            {isLoading ? (
              <Skeleton
                variant="rectangular"
                width="100%"
                height={60}
                sx={{ backgroundColor: "lightgray", borderRadius: "8px" }}
              />
            ) : (
              <Box sx={{ position: "relative" }} ref={diagnosisFieldRef}>
                <TextField
                  variant="outlined"
                  id="diagnosis"
                  label="Diagnosis"
                  className="step-three"
                  value={data?.diagnosis}
                  onChange={(e) => {
                    isDiagnosisTyping.current = true;
                    handleInputChange("diagnosis")(e);
                  }}
                  onKeyDown={(e) => {
                    if (showDiagnosisDrop && diagnosisSuggestions.length > 0) {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleDiagnosisSuggestionSelect(
                          diagnosisSuggestions[diagnosisFocusedIndex],
                        );
                        return;
                      }
                      if (e.key === "ArrowDown") {
                        e.preventDefault();
                        setDiagnosisFocusedIndex((i) =>
                          Math.min(i + 1, diagnosisSuggestions.length - 1),
                        );
                        return;
                      }
                      if (e.key === "ArrowUp") {
                        e.preventDefault();
                        setDiagnosisFocusedIndex((i) => Math.max(i - 1, 0));
                        return;
                      }
                      if (e.key === "Escape") {
                        setShowDiagnosisDrop(false);
                        return;
                      }
                    }
                    handleKeyDown(e, "diagnosis");
                  }}
                  onBlur={() => {
                    isDiagnosisTyping.current = false;
                    setTimeout(() => setShowDiagnosisDrop(false), 150);
                  }}
                  fullWidth
                  name="diagnosis"
                  type="text"
                  multiline
                  rows={2}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        position="end"
                        sx={{ alignSelf: "flex-start", mt: "6px" }}
                      >
                        {diagnosisSearching ? (
                          <CircularProgress
                            size={14}
                            sx={{ color: "neutral.teal" }}
                          />
                        ) : debouncedDiagnosis && (aiLoading || !aiResult) ? (
                          aiLoading ? (
                            <CircularProgress
                              size={18}
                              sx={{ color: "neutral.teal" }}
                            />
                          ) : (
                            <Tooltip title="Search AI template for this diagnosis">
                              <IconButton
                                size="small"
                                onClick={handleAiSearch}
                                sx={{
                                  color: "action.active",
                                  mt: "6px",
                                  "&:hover": {
                                    color: "neutral.teal",
                                    mt: "6px",
                                  },
                                }}
                              >
                                <AutoAwesomeIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )
                        ) : null}

                        <MicButton
                          isListening={diagnosisMic.isListening}
                          onStart={diagnosisMic.startListening}
                          onStop={diagnosisMic.stopListening}
                        />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    ...textfieldTextPrep,
                    "& .MuiOutlinedInput-root": {
                      fontFamily: "Lato",
                      borderRadius: "8px",
                      height: "60px",
                      padding: "9px 14px !important",
                      "& input": {
                        padding: "4px",
                        fontSize: "14px",
                      },
                    },
                  }}
                />
                {showDiagnosisDrop && diagnosisSuggestions.length > 0 && (
                  <Paper
                    elevation={4}
                    sx={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      zIndex: 1300,
                      maxHeight: 220,
                      overflowY: "auto",
                      borderRadius: "8px",
                      mt: "2px",
                    }}
                  >
                    <List dense disablePadding>
                      {diagnosisSuggestions.map((item, idx) => (
                        <ListItemButton
                          key={item.id}
                          onMouseDown={() =>
                            handleDiagnosisSuggestionSelect(item)
                          }
                          onMouseEnter={() => setDiagnosisFocusedIndex(idx)}
                          selected={idx === diagnosisFocusedIndex}
                          sx={{
                            px: 2,
                            py: 0.75,
                            "&.Mui-selected": {
                              backgroundColor: "rgba(0,122,153,0.12)",
                            },
                            "&.Mui-selected:hover": {
                              backgroundColor: "rgba(0,122,153,0.18)",
                            },
                            "&:hover": {
                              backgroundColor: "rgba(0,122,153,0.08)",
                            },
                          }}
                        >
                          <ListItemText
                            primary={item.value}
                            primaryTypographyProps={{
                              fontSize: "13px",
                              fontFamily: "Lato",
                            }}
                          />
                        </ListItemButton>
                      ))}
                    </List>
                  </Paper>
                )}
              </Box>
            )}
          </Grid>
        </Grid>

        <Grid sx={{ p: 0 }} container spacing={2} mt={0.5}>
          {/* <Grid item md={1.5} mt={1}>
          <Typography variant="body1_text_bold" color={"neutral.black"} fontWeight={'420'}>
            Notes
          </Typography>
        </Grid> */}
          <Grid item xs={12}>
            {isLoading ? (
              <Skeleton
                variant="rectangular"
                width="100%"
                height={60}
                sx={{ backgroundColor: "lightgray", borderRadius: "8px" }}
              />
            ) : (
              <TextField
                multiline
                rows={2}
                id="notes"
                className="step-four"
                name="notes"
                onKeyDown={(e) => handleKeyDown(e, "notes")}
                sx={{
                  ...textfieldTextPrep,
                  "& .MuiOutlinedInput-root": {
                    fontFamily: "Lato",
                    borderRadius: "8px",
                    height: "60px",
                    padding: "9px 14px !important",
                    "& input": {
                      padding: "4px",
                      fontSize: "14px",
                    },
                  },
                }}
                value={data.notes}
                onChange={handleInputChange("notes")}
                fullWidth
                label="Notes"
                type="text"
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={{ alignSelf: "flex-start", mt: "6px" }}
                    >
                      <MicButton
                        isListening={notesMic.isListening}
                        onStart={notesMic.startListening}
                        onStop={notesMic.stopListening}
                      />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          </Grid>
        </Grid>

        <Grid sx={{ p: 0 }} container spacing={2} mt={0.5}>
          {/* <Grid item md={1.5} mt={1}>
          <Typography variant="body1_text_bold" color={"neutral.black"}>
            Self Notes
          </Typography>
        </Grid> */}

          <Grid item xs={12}>
            {isLoading ? (
              <Skeleton
                variant="rectangular"
                width="100%"
                height={60}
                sx={{ backgroundColor: "lightgray", borderRadius: "8px" }}
              />
            ) : (
              <TextField
                multiline
                rows={2}
                id="self_notes"
                className="step-five"
                sx={{
                  ...textfieldTextPrep,
                  "& .MuiOutlinedInput-root": {
                    fontFamily: "Lato",
                    borderRadius: "8px",
                    height: "60px",
                    padding: "9px 14px !important",
                    "& input": {
                      padding: "4px",
                      fontSize: "14px",
                    },
                  },
                }}
                // Self Notes field:
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={{ alignSelf: "flex-start", mt: "6px" }}
                    >
                      <MicButton
                        isListening={selfNotesMic.isListening}
                        onStart={selfNotesMic.startListening}
                        onStop={selfNotesMic.stopListening}
                      />
                    </InputAdornment>
                  ),
                }}
                value={data.selfNotes}
                name="selfNotes"
                onKeyDown={(e) => handleKeyDown(e, "selfNotes")}
                onChange={handleInputChange("selfNotes")}
                fullWidth
                // placeholder="Self Notes"
                label="Self Notes"
                type="text"
              />
            )}
          </Grid>
        </Grid>

        <Grid sx={{ p: 0 }} container spacing={2} mt={0.5}>
          {/* <Grid item md={1.5} mt={3}>
          <Typography
            variant="body1_text_bold"
            color={"neutral.black"}
            sx={{ mr: "2px" }}
          >
            Special Instructions
          </Typography>
        </Grid> */}

          <Grid item xs={12}>
            {treatmentShortCodeList?.length > 0 &&
              treatmentShortCodeList.map(
                (shortCode) =>
                  shortCode[1] ? (
                    <Chip
                      onClick={() => handleChangeSplInst(shortCode[1])}
                      // color={"text.tomato"}
                      sx={{ ...slotChip, mr: "5px", cursor: "pointer" }}
                      key={shortCode[0]} // Ensure unique key is provided, assuming shortCode[0] is unique
                      label={shortCode[1]}
                      clickable
                      variant="outlined"
                      color="primary"
                    >
                      {shortCode[1]}
                    </Chip>
                  ) : null, // Return null if shortCode[1] is falsy
              )}

            {isLoading ? (
              <Skeleton
                variant="rectangular"
                width="100%"
                height={60}
                sx={{ backgroundColor: "lightgray", borderRadius: "8px" }}
              />
            ) : (
              <TextField
                multiline
                rows={2}
                name="splInst"
                onKeyDown={(e) => handleKeyDown(e, "splInst")}
                className="step-six"
                id="special_instructions"
                sx={{
                  ...textfieldTextPrep,
                  marginTop: "14px",
                  "& .MuiOutlinedInput-root": {
                    fontFamily: "Lato",
                    borderRadius: "8px",
                    height: "60px",
                    padding: "9px 14px !important",
                    "& input": {
                      padding: "4px",
                      fontSize: "14px",
                    },
                  },
                }}
                // Special Instructions field:
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={{ alignSelf: "flex-start", mt: "6px" }}
                    >
                      <MicButton
                        isListening={splInstMic.isListening}
                        onStart={splInstMic.startListening}
                        onStop={splInstMic.stopListening}
                      />
                    </InputAdornment>
                  ),
                }}
                value={data.splInst}
                onChange={handleInputChange("splInst")}
                fullWidth
                label="Special Instructions"
                // placeholder="Special Instructions"
                type="text"
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <PatientSummaryDialog
        openSummaryModal={openSummaryModal}
        handleCloseSummary={handleCloseSummary}
        voiceSummary={voiceSummary}
        isFetching={false}
      />

      <CustomModal
        customStyles={{ minWidth: "50%" }}
        open={dasCalculatorModal}
        onClose={() => setDasCalculatorModal(false)}
      >
        <DAS28
          onClose={() => setDasCalculatorModal(false)}
          patient={patientDetailsData}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ width: "90%" }}
        open={dasCalculatorHistoryModal}
        onClose={() => setDasCalculatorHistoryModal(false)}
      >
        <HistoryDas28
          onClose={() => setDasCalculatorHistoryModal(false)}
          patient={patientDetailsData}
        />
      </CustomModal>

      {/* SOAP Note Modal */}
      <CustomModal
        open={openSoapModal}
        onClose={() => setOpenSoapModal(false)}
        title="SOAP Clinical Note"
        customStyles={{ minWidth: "75%", maxWidth: "90%" }}
      >
        <SOAP
          soapSummary={soapSummary}
          patientName={commonData?.patientForm?.fullName} // optional — shown in patient strip & header
          // visitDate=// optional — shown in doc meta
          doctor={prescriptionData?.appointment?.doctor?.full_name}
          onClose={() => setOpenSoapModal(false)}
        />
      </CustomModal>

      <CustomModal
        open={openJointModal}
        onClose={() => setJointModal(false)}
        title="Joint Assessment"
        customStyles={{ minWidth: "75%", maxWidth: "90%" }}
      >
        <JointAssessment
          // soapSummary={soapSummary}
          patientId={patientDetailsData?.id}
          resourceId={appointmentData?.id}
          onClose={() => setJointModal(false)}
        />
      </CustomModal>

      {/* OCR — Medical Image Analysis Modal */}
      <CustomModal
        open={openOcrModal}
        onClose={() => setOcrModal(false)}
        customStyles={{ minWidth: "520px", maxWidth: "680px" }}
      >
        <OCRModal
          onClose={() => setOcrModal(false)}
          ocrConfig={isOcrEnabled}
          patientId={patientDetailsData?.id}
          appointmentId={appointmentData?.id}
          onResultsReady={(r) => setOcrResults(r)}
        />
      </CustomModal>

      {/* Smart Template Suggestion Dialog */}
      <Dialog
        open={smartPrompt}
        onClose={() => setSmartPrompt(false)}
        PaperProps={{ sx: { borderRadius: "12px", p: 1 } }}
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: "16px" }}>
          Save as Template?
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" mb={2}>
            You&apos;ve used &quot;{data.diagnosis}&quot; {aiResult?.counter}{" "}
            times. Want to save it as a template for future use?
          </Typography>
          <TextField
            autoFocus
            fullWidth
            size="small"
            label="Template Name"
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions sx={{ pb: 2, pr: 2, gap: 1 }}>
          <Button
            variant="outlined"
            size="small"
            onClick={() => setSmartPrompt(false)}
            sx={{ textTransform: "none", borderRadius: "8px" }}
          >
            No
          </Button>
          <Button
            variant="contained"
            size="small"
            disabled={templateSaving || !templateName.trim()}
            onClick={async () => {
              await handleAddTemplate(templateName.trim());
            }}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              backgroundColor: "neutral.teal",
              "&:hover": { backgroundColor: "neutral.tealDark" },
            }}
          >
            {templateSaving ? (
              <CircularProgress size={14} sx={{ color: "#fff" }} />
            ) : (
              "Yes, Save"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Template Name Dialog (from Save as Template button) */}
      <Dialog
        open={templateNameDialog}
        onClose={() => setTemplateNameDialog(false)}
        PaperProps={{ sx: { borderRadius: "12px", p: 1, minWidth: "360px" } }}
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: "16px" }}>
          Save as Template
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            size="small"
            label="Template Name"
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions sx={{ pb: 2, pr: 2, gap: 1 }}>
          <Button
            variant="outlined"
            size="small"
            onClick={() => setTemplateNameDialog(false)}
            sx={{ textTransform: "none", borderRadius: "8px" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="small"
            disabled={templateSaving || !templateName.trim()}
            onClick={async () => {
              await handleAddTemplate(templateName.trim());
            }}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              backgroundColor: "neutral.teal",
              "&:hover": { backgroundColor: "neutral.tealDark" },
            }}
          >
            {templateSaving ? (
              <CircularProgress size={22} sx={{ color: "#fff" }} />
            ) : (
              "Confirm"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TreatmentDetail;
